<template>
  <v-container fluid>
    <v-layout
      v-if = "selectedBroadcast"
      row 
      wrap>
      <h1 v-if = "selectedBroadcast && selectedBroadcast.name">
        Broadcast <span class="primary--text">({{ selectedBroadcast.name }})</span>
        <supported-platforms
          :manual-channels = "[ selectedBroadcast.app.provider ]"
          :placeholder = "null"
          class="mt-3"
          style="display: inline-block; margin-left: -10px"/>
      </h1>
      <v-spacer />
      <v-btn
        color="primary"
        style="height: 40px !important;"
        @click="sendMessage">Send</v-btn>
    </v-layout>
    <!-- <v-flex xs12>
      <code>{{ selectedBroadcast }}</code>
    </v-flex> -->
    <v-flex xs12>
      <broadcast-receivers />
    </v-flex>
    <v-flex xs12>
      <broadcast-replies />
    </v-flex>
  </v-container>
</template>

<script>
import BroadcastReceivers from '../components/broadcasts/BroadcastReceivers'
import BroadcastReplies from '../components/broadcasts/BroadcastReplies'
import SupportedPlatforms from '../components/block-build/blocks/SupportedPlatforms.vue'
export default {
  name: 'BroadcastSingle',
  components: {
     BroadcastReceivers,
     BroadcastReplies,
     SupportedPlatforms
  },
  data() {
    return {}
  },
  computed: {
    selectedBroadcast() {
      return this.$store.state.broadcasts.selectedBroadcast
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await this.getBroadcast()
    },
    async getBroadcast() {
      await this.$store.dispatch(
        'broadcasts/get/current',
        this.$route.params.id
      )
    },
    sendMessage() {
      this.$store.dispatch('setLoader', true)
      this.$http_chat.post(`/broadcasts/${this.selectedBroadcast._id}/send`).then(()=>{
        this.$store.dispatch('setLoader', false)
      }).catch((err)=>{
        this.$store.dispatch('setLoader', false)
        this.$store.dispatch('setErrorMessage', true)
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
